import { StackType } from "../types/stacksTypes";

export const stacksMocks: StackType[] = [
  {
    imageUrl: "/images/icons/react-icon.png",
    type: "프레임워크",
    detail: "React.js",
  },
  {
    imageUrl: "/images/icons/next.png",
    type: "프레임워크",
    detail: "Next.js",
  },
  {
    imageUrl: "/images/icons/ts.svg",
    type: "언어",
    detail: "Typescript",
  },
  {
    imageUrl: "/images/icons/js.png",
    type: "언어",
    detail: "Javascript",
  },
  {
    imageUrl: "/images/icons/tailwind.png",
    type: "라이브러리",
    detail: "tailwindcss",
  },
  {
    imageUrl: "/images/icons/zustand.webp",
    type: "라이브러리",
    detail: "zustand",
  },
  {
    imageUrl: "/images/icons/sass.png",
    type: "라이브러리",
    detail: "sass",
  },
  {
    imageUrl: "/images/icons/scomp.png",
    type: "라이브러리",
    detail: "styled-components",
  },
  {
    imageUrl: "/images/icons/github.png",
    type: "협업 툴",
    detail: "github",
  },
];
